import React, {useEffect, useState} from "react";
import '../../styles/components/settings/settings-section.scss';
import ExternalLink from "../common/ExternalLink";
import Button from "../common/Button";
import nativeBridge from "../../services/nativeBridge";
import {useAppSelector} from "../../redux/hooks";
import {settingsStore} from "../../redux/settings/settingsStore";
import {useNavigate} from "react-router-dom";
import {settingsPagePaths} from "../../config/config";
import {baseUrlForWebsite} from "../../client/PlaygroundSettings";

export default function PrivacySection() {
  const isUMPConsentRequired = useAppSelector(settingsStore.getIsUMPConsentRequired);
  const pdcStatus = useAppSelector(settingsStore.getPDCStatus);
  const navigate = useNavigate();
  const isPdcConsentApplicable = useAppSelector(settingsStore.getIsPdcConsentApplicable);
  const [isButtonClicked, setIsButtonClicked] = useState(false);

  const onManagePrivacyButton_click = () => {
    setIsButtonClicked(true);
    nativeBridge.sendMessageToNative({type: 'privacy.privacySettingsForm_requested'});
    settingsStore.setPDCStatus('unknown');
  }

  useEffect(() => {
    if (pdcStatus === 'unknown' && isPdcConsentApplicable && isButtonClicked) {
      navigate(`/onboarding/disclosure-and-consent?from=${settingsPagePaths.privacy}`);
    }
  }, [pdcStatus, navigate, isPdcConsentApplicable, isButtonClicked]);

  return (
    <div className="settings-section privacy">
      <header>Privacy</header>
      <main className="settings">
        <section>
          <header>Privacy Policy</header>
          <p>Learn how we collect and use your personal data to provide you with the best experience.</p>
          <footer>
            <ExternalLink url={`${baseUrlForWebsite}/about/privacy-policy`} title={"Privacy Policy"} />
          </footer>
        </section>
        {isUMPConsentRequired
          ?
          <section className="not-desktop">
            <header>Manage Privacy Choices</header>
            <p>Review or change ad consent.</p>
            <footer>
              <Button
                onClick={onManagePrivacyButton_click}
                text={"Manage"}
                buttonType={"primary"}
              />
            </footer>
          </section>
          :
          null
        }
      </main>
    </div>
  );
}
